import { render, staticRenderFns } from "./BMap.vue?vue&type=template&id=7bd713d8&scoped=true&"
import script from "./BMap.vue?vue&type=script&lang=js&"
export * from "./BMap.vue?vue&type=script&lang=js&"
import style0 from "./BMap.vue?vue&type=style&index=0&id=7bd713d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd713d8",
  null
  
)

component.options.__file = "BMap.vue"
export default component.exports